/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SenderRemoveRequest
 */
export interface SenderRemoveRequest {
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the SenderRemoveRequest interface.
 */
export function instanceOfSenderRemoveRequest(value: object): value is SenderRemoveRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function SenderRemoveRequestFromJSON(json: any): SenderRemoveRequest {
    return SenderRemoveRequestFromJSONTyped(json, false);
}

export function SenderRemoveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SenderRemoveRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function SenderRemoveRequestToJSON(json: any): SenderRemoveRequest {
    return SenderRemoveRequestToJSONTyped(json, false);
}

export function SenderRemoveRequestToJSONTyped(value?: SenderRemoveRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
    };
}

